export const deleteProp = (object, key) => {
    const mappedObject = new Map(Object.entries(object));
    const isArray = Array.isArray(key);
    if (isArray)
        key.forEach((key) => mappedObject.delete(key));
    if (!isArray)
        mappedObject.delete(key);
    return Object.fromEntries(mappedObject.entries());
};
//# sourceMappingURL=deleteProp.js.map